export default __webpack_public_path__ + "static/media/filter-header.5037a39f.png";